class CartDrawer extends DrawerFixed {
  constructor() {
    super();
    
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // 监听购物车数量更新事件
    document.addEventListener('afterUpdateQuantity', () => {
      this.updatePromotionBar();
    });

    // MutationObserver for detecting dynamic content updates
    this.observeContentChanges();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    document.documentElement.classList.add('no-scroll');
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.updateProductRecommendation();
    super.open(triggeredBy);
    this.updateDrawerFooterPadding();
  }

  updateDrawerFooterPadding() {
    try {
      const footer = this.querySelector('.drawer__footer');
      if (footer) {
        const footerHeight = footer.offsetHeight;
        const computedStyle = window.getComputedStyle(footer);
        const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
        const totalHeight = footerHeight + marginBottom;
        this.style.setProperty('--drawer-bottom-padding', `${totalHeight}px`);
      }
    } catch (e) {
      // 静默处理，不影响购物车功能
    }
  }

  close(evt) {
    const currentFooterAction = this.querySelector('cart-drawer-footer-action.open');
    if(currentFooterAction) {
      currentFooterAction.closeActionContent();
    }
    if(!this.classList.contains('busy') || !evt.target.closest('cart-drawer-footer-action')) {
      super.close(evt);
      document.documentElement.classList.remove('no-scroll');
    }    
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  // Observes changes in the content of the drawer
  observeContentChanges() {
    const drawerContent = this.querySelector('.drawer__inner');
    const observer = new MutationObserver(() => {
      // Recalculate footer padding whenever content changes
      this.updateDrawerFooterPadding();
    });

    observer.observe(drawerContent, {
      childList: true, // Listen for added or removed child nodes
      subtree: true,  // Listen for changes in all descendants
    });
  }

  renderContents(parsedState) {
    console.log("CartDrawer renderContents - parsedState:", parsedState);
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(sectionElement) {
        sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.updatePromotionBar();
    });
  }

  updatePromotionBar() {
    const promotionBar = document.querySelector('yg-promotion-bar');
    if (promotionBar && promotionBar.updateCartTotal) {
      // 获取购物车总价元素（尝试多个可能的选择器）
      const totalElement = this.querySelector('.totals__subtotal-value') 
                        || this.querySelector('.cart-drawer__total-price')
                        || this.querySelector('[data-cart-total]')
                        || document.querySelector('.cart-drawer__footer--subtotal .price');
      
      if (totalElement) {
        const totalText = totalElement.textContent || totalElement.innerText || totalElement.getAttribute('data-cart-total') || '0';
        promotionBar.updateCartTotal(totalText);
      } else {
        // 如果找不到总价元素，尝试从 cart 对象获取
        if (window.cart && window.cart.total_price) {
          const cartTotal = window.cart.total_price / 100; // Shopify 价格以分为单位
          promotionBar.updateCartTotal(cartTotal.toString());
        }
      }
    }
  }

  updateProductRecommendation() {
    this.productRecommendation = this.querySelector('cart-product-recommendations');
    if(this.productRecommendation) {
      const cartItemsWrapper = this.querySelector('.cart-drawer__items');
      cartItemsWrapper.classList.toggle('cart-drawer__items--large', cartItemsWrapper.querySelectorAll('.cart-item').length > 1);
      this.productRecommendation.update();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.cart-drawer__items'
      },
      {
        id: 'cart-drawer',
        selector: '.cart-drawer__footer--subtotal'
      },
      {
        id: 'cart-drawer',
        selector: '#yg-cart-promotion-wrapper'
      },
      {
        id: 'cart-drawer',
        selector: '.yg-drawer-count-wrapper'
      },
      {
        id: 'cart-drawer',
        selector: 'yg-cart-discount'
      },
      {
        id: 'cart-drawer',
        selector: '#yg-recommend-products-wrapper'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }
}

// 购物车抽屉专用的删除按钮
class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const line = this.dataset.index;
      
      // 显示 loading
      const lineItem = document.getElementById(`CartDrawer-Item-${line}`);
      const loadingOverlay = lineItem?.querySelector('.loading-overlay');
      if (loadingOverlay) loadingOverlay.classList.remove('hidden');
      
      // 获取 cart-drawer-items 并调用 updateQuantity
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        cartDrawerItems.enableLoading(line);
        
        const body = JSON.stringify({
          line: line,
          quantity: 0,
          sections: cartDrawerItems.getSectionsToRender().map(s => s.id),
          sections_url: window.location.pathname
        });
        
        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
          .then(response => response.text())
          .then(state => {
            const parsedState = JSON.parse(state);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const errors = document.getElementById('CartDrawer-CartErrors');
            
            if (parsedState.errors) {
              if (errors) errors.classList.remove('hidden');
              return;
            }
            
            // 使用 CartDrawerItems 的 renderContents 更新
            cartDrawerItems.renderContents(parsedState, lineItem, 'minus');
            document.dispatchEvent(new CustomEvent('afterUpdateQuantity'));
            if (errors) errors.classList.add('hidden');
          })
          .catch(() => {
            const errors = document.getElementById('CartDrawer-CartErrors');
            if (errors) {
              errors.classList.remove('hidden');
              errors.querySelector('span').textContent = window.cartStrings.error;
            }
          })
          .finally(() => {
            // 隐藏 loading
            if (loadingOverlay) loadingOverlay.classList.add('hidden');
            cartDrawerItems.disableLoading();
          });
      }
    });
  }
}

customElements.define('cart-drawer', CartDrawer);
if (!customElements.get('cart-drawer-remove-button')) {
  customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);
}

// 购物车抽屉专用的 items 组件
class CartDrawerItems extends CartItems {
  constructor() {
    super();
  }

  getSectionsToRender() {
    return [
      { section: 'cart-drawer', id: 'cart-drawer', selector: '.cart-drawer__items' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '.cart-drawer__footer--subtotal' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '#yg-cart-promotion-wrapper' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '.yg-drawer-count-wrapper' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: 'yg-cart-discount' },
      { section: 'cart-drawer', id: 'cart-drawer', selector: '#yg-recommend-products-wrapper' },
      { section: 'cart-icon-bubble', id: 'cart-icon-bubble', selector: '.cart-count-bubble' },
    ];
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`CartDrawer-LineItemError-${line}`);
    if(lineItemError) {
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      lineItemError.classList.toggle('hidden', !message);
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  renderContents(parsedState, lineItem, name) {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    if (cartDrawerWrapper) {
      cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    this.getSectionsToRender().forEach((section => {
      const sectionElement = document.querySelector(section.selector);
      if (sectionElement && parsedState.sections && parsedState.sections[section.id]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(parsedState.sections[section.id], 'text/html');
        const newContent = doc.querySelector(section.selector)?.innerHTML || parsedState.sections[section.id];
        sectionElement.innerHTML = newContent;
      }
    }));

    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      const emptyContent = cartDrawerWrapper.querySelector('.drawer__inner-empty');
      const emptyLink = cartDrawerWrapper.querySelector('.drawer__inner-empty a');
      if (emptyContent && emptyLink) {
        trapFocus(cartDrawerWrapper, emptyLink);
      }
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      const firstItemName = cartDrawerWrapper.querySelector('.cart-item__name');
      if (firstItemName) {
        trapFocus(cartDrawerWrapper, firstItemName);
      }
    }

    this.updateProductRecommendation();
  }

  updateProductRecommendation() {
    const recommendation = this.querySelector('cart-product-recommendations');
    if(recommendation) {
      recommendation.update();
    }
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}

// 初始化购物车抽屉中的自定义元素
function initCartDrawerElements(container) {
  if (!container) container = document;
  
  // 初始化删除按钮
  container.querySelectorAll('cart-drawer-remove-button:not([initialized])').forEach(el => {
    el.setAttribute('initialized', '');
  });
}

// 监听购物车抽屉的 renderContents
const originalRenderContents = CartDrawer.prototype.renderContents;
CartDrawer.prototype.renderContents = function(parsedState) {
  originalRenderContents.call(this, parsedState);
  
  // 在内容更新后重新初始化自定义元素
  setTimeout(() => {
    initCartDrawerElements(this);
  }, 0);
};
